export const playbackRates = [0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.5, 2];
